import { Box, Grid, Typography, TextField } from "@mui/material";
import { useState } from "react";
import { FilterEntriesBySearch } from "../controllers/utils";

// COMPONENTS
import Charge from "./Charge";
import ChargeSeverity from "./ChargeSeverity";
import LoadingSpinner from "./LoadingSpinner";

// CHARGES LIST
export default function ChargesList({ setChargesCalculator, charges, setShowNotification, setNotificationText, isLoading }: ChargesListProps) {
    const [searchQuery, setSearchQuery] = useState('');
    const filteredCharges = FilterEntriesBySearch(searchQuery, charges);

    // RETURN ELEMENT
    return (
        <Box sx={{ py: 5 }}>
            <Typography color="white" align="center" fontFamily="Public Sans" gutterBottom>
                <b>FELONY OFFENSES</b>: SUGGESTED INCARCERATION TIMES ARE ABLE TO BE REDUCED INDIVIDUALLY OR BY THE TOTAL OF ALL OFFENSES BY UP TO 20%. LAWYERS MAY ATTEMPT TO REDUCE THIS UP TO 50% IF PRESENT.
            </Typography>

            <Typography color="white" align="center" fontFamily="Public Sans" sx={{ mt: 3.55 }}>
                <b>MISDEMEANOR OFFENSES</b>: SUGGESTED INCARCERATION TIMES ARE ABLE TO BE REDUCED INDIVIDUALLY OR BY THE TOTAL OF ALL OFFENSES BY UP TO 50%
            </Typography>

            {/* SEARCH BAR */}
            <Box sx={{ mt: 3, p: 2, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                <TextField
                    fullWidth
                    onInput={(e: any) => setSearchQuery(e.target.value)}
                    label="Enter a charge name"
                    value={searchQuery}
                    variant="outlined"
                    placeholder="Search..."
                    autoComplete="penalcode_chargename"
                    size="small"
                />
            </Box>

            {/* CHARGE SEVERITIES */}
            <Box id="chargeseverities" sx={{ mt: 3, p: 2, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                <ChargeSeverity severity="Capital" />
                <ChargeSeverity severity="Felony" />
                <ChargeSeverity severity="Misdemeanor" />
            </Box>

            {/* CHARGES */}
            <Box id="list" sx={{ mt: 3, p: 3, bgcolor: 'var(--darkbackground)', borderRadius: 2 }}>
                {isLoading ? 
                    <LoadingSpinner />  
                :
                    <Grid container spacing={3}>
                        {filteredCharges?.map((charge: any, index: number) => (
                            <Grid item key={index} xs={12} sm={6} md={3}>
                                <Charge
                                    type="charge"
                                    setCalculatorData={setChargesCalculator}
                                    charge={charge}
                                    setShowNotification={setShowNotification}
                                    setNotificationText={setNotificationText}
                                />
                            </Grid>
                        ))}
                    </Grid>
                }
            </Box>
        </Box>
    )
}
